import OuterSidebar from "./OuterSidebar";
import TaskView from "@/components/TaskView";
import { useAddAccountTour } from "@/hooks";
import "shepherd.js/dist/css/shepherd.css";

const AppShell = () => {
  
  useAddAccountTour();

  return (
    <div className="flex h-screen max-md:h-dvh">
      <OuterSidebar />
      <div className="flex-1 overflow-hidden">
        <TaskView />
      </div>
    </div>
  );
};

export default AppShell;
